module.exports = __webpack_public_path__ + "static/media/10.39742fc0.png";